"use strict";Object.defineProperty(exports, "__esModule", {value: true});var _uuid = require('uuid');

 const uuidv4 = () => _uuid.v4.call(void 0, ); exports.uuidv4 = uuidv4

 const EMPTY_BLUID = '00000000-0000-0000-0000-000000000000'; exports.EMPTY_BLUID = EMPTY_BLUID
